export type UserShortcuts = {
  hasClientRole: boolean;
  hasManagerRole: boolean;
  hasSmsProvider: boolean;
  hasVoiceProvider: boolean;
  isClient: boolean;
  isCometeOnTime: boolean;
  isManager: boolean;
  isMultiClient: boolean;
  isPartner: boolean;
  isResource: boolean;
  isSubClient: boolean;
};

/**
 * Calcule les raccourcis dérivés du user : rôles ET paramétrages utilisateur
 * (fournisseur_sms, voice_partner_configured).
 * Fonction pure — aucun side effect.
 */
export function computeUserShortcuts(
  role: string,
  user: { fournisseur_sms?: string; voice_partner_configured?: boolean; userClientIds?: number[] }
): UserShortcuts {
  return {
    hasClientRole: role.includes('client'),
    hasManagerRole: role.includes('manager'),
    hasSmsProvider: !!user.fournisseur_sms,
    hasVoiceProvider: !!user.voice_partner_configured,
    isClient: role === 'client',
    isCometeOnTime: role === 'clocking_device',
    isManager: role === 'manager',
    isMultiClient: role === 'client' && !!user.userClientIds,
    isPartner: role === 'manager_partner',
    isResource: role === 'resource',
    isSubClient: role === 'client_user'
  };
}
